module.exports = __webpack_public_path__ + "static/contribute-2ba4ef18976294c566e8394f79ffe05e.jpg";